export const getSession = (): string | null => {
  return localStorage.getItem(LOGIN_SESSION)
};

export const setSession = (value : string)  => {
  localStorage.setItem(LOGIN_SESSION, value)
};

export const LOGIN_SESSION = 'sessionKey';
